<template>
  <ModalShell :visible="true" :z-index="2000" @close="close" :teleport="false">
    <div class="IMC_help_dialog">
      <div class="imc-help-container" @click.stop>
        <div class="mgx_close_btn close_btn_pos" @click="close">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <IMC_help />
      </div>
    </div>
  </ModalShell>
</template>

<script setup lang="ts">
import ModalShell from '../common/ModalShell.vue'
import IMC_help from './IMC_help.vue'

interface Emits {
  (e: 'close'): void
}

const emit = defineEmits<Emits>()

const close = () => {
  emit('close')
}
</script>

<style scoped lang="less">
.IMC_help_dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  -webkit-app-region: no-drag;
}

.imc-help-container {
  position: relative;
  width: min(820px, calc(100vw - 48px));
  max-height: calc(100vh - 64px);
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--bg-subtle);
  border-radius: var(--radius-l);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12);
  animation: modal-in 0.4s var(--transition-base);
  contain: layout paint;
  will-change: transform, opacity;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent !important;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: var(--radius-pill);
  }
}

@keyframes modal-in {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.close_btn_pos {
  position: sticky;
  top: 16px;
  margin-left: auto;
  right: 16px;
  z-index: 10;
}

@media (max-width: 900px) {
  .IMC_help_dialog {
    width: 100%;
  }

  .imc-help-container {
    width: calc(100vw - 32px);
    max-height: calc(100vh - 32px);
  }
}
</style>
